export default {
    // 获取所有地址
    async autoLoginByToken(params,type) {
        let actiontype = 'user/autoLoginByToken';
        return await this.fetchMall(actiontype, params, 'noalert')
    },
    // 地址管理
    async getMyAddressList(params) {
        let actiontype = 'user/getMyAddressList';
        return await this.fetchMall(actiontype, params)
    },
    // 添加地址  
    async addAddress(params) {
        let actiontype = 'user/addAddress';
        return await this.fetchMall(actiontype, params)
    },
    // 修改地址
    async modifyAddress(params) {
        let actiontype = 'user/modifyAddress';
        return await this.fetchMall(actiontype, params)
    },
    // 删除地址
    async deleteAddress(params) {
        let actiontype = 'user/deleteAddress';
        return await this.fetchMall(actiontype, params)
    },
    // 获取所有地址
    async getAllAddress(params,type) {
        let actiontype = 'user/getAllAddress';
        return await this.fetchMall(actiontype, params, type)
    },
    // 获取版块商品
    async getGoodsProductList(params) {
        let actiontype = 'goods/getGoodsProductList';
        return await this.fetchMall(actiontype, params)
    },
    // 商品详情
    async getSaleGoodsDetail(params) {
        let actiontype = 'goods/getSaleGoodsDetail';
        return await this.fetchMall(actiontype, params)
    },
    // 获取商品规格  
    async getGoodsSku(params) {
        let actiontype = 'goods/getGoodsSku';
        return await this.fetchMall(actiontype, params)
    },
    // 获取商品规格(机+购物车)  
    async getTicketAndCartGoodsSku(params) {
        let actiontype = 'goods/getTicketAndCartGoodsSku';
        return await this.fetchMall(actiontype, params)
    },
    // 获取机+购物车推荐商品 
    async getTicketCartRuleAndGoods(params) {
        let actiontype = 'goods/getTicketCartRuleAndGoods';
        return await this.fetchMall(actiontype, params)
    },
    // 订单详情
    async getMyOrderDetail(params) {
        let actiontype = 'order/getMyOrderDetail'
        return await this.fetchMall(actiontype, params)
    },
    // 优惠券兑换码
    async orderCreateByCouponCode(params) {
        let actiontype = 'order/orderCreateByCouponCode';
        return await this.fetchMall(actiontype, params);
    },
    async couponCodeGetImageVerifyCode(params) {
        let actiontype = "user/getImageVerifyCode";
        return await this.fetchMall(actiontype, params);
    }
}


// WEBPACK FOOTER //
// ./src/interfaces/modules/mall.js